<mat-chip-set class="status-chip-set">
	<mat-chip
		class="status-chip"
		[ngClass]="getChipStyling(getDeviceStatus(device))"
		[attr.data-automation-id]="getDeviceStatus(device) === 'inService' ? 'device-status-in-service-chip' : null"
		>&bull;&NonBreakingSpace;{{ getStatusName(getDeviceStatus(device)) }}</mat-chip
	>
	@if (isReadyForRemoval()) {
		<mat-chip
			class="status-chip status-chip-inactive"
			data-automation-id="device-status-ready-for-removal-chip"
			i18n="@@deviceAbout-LabelReadyForRemoval"
			>&bull;&NonBreakingSpace;Ready for Removal</mat-chip
		>
	}
</mat-chip-set>
